<ion-input [value]="value?.name" [readonly]="true" (click)="openCaporepartoSelection()"> </ion-input>
